import Service from "../../Service";

const resource = "ChartRepport/";
export default {
    GetHarvestJabaQuantityReport(parameters, requestID) {
        return Service.post(resource + "GetHarvestJabaQuantityReport", parameters, {
            params: { requestID: requestID },
        });
    }
};